import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe, Location } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';

@Component({
  selector: 'app-verification-doc',
  templateUrl: './verification-doc.component.html',
  styleUrls: ['./verification-doc.component.scss']
})
export class VerificationDOCComponent implements OnInit {
  VodForm: FormGroup;
  @ViewChild('fileUploader') fileUploader: ElementRef;

  StuId: any;
  InstId: any;
  CollegeList: any;
  filteredCollegeList: any;
  courseList: any;
  filteredCourseList: any;
  StuFullName: string;
  RegnNo: string;
  formattedPrn: string;
  PreFix: any;

  Table = false;
  Approved = false;
  SaveBtn = false;
  UpdateBtn = false;
  PayFee = false;
  PayRecpt = false;
  DocTable = false;
  DocView = false;
  SaveDisabled = false;
  UpdateDisabled = false;
  PayDisabled = false;
  isdisabled = false;
  isreadonly = false;
  fileName: string;
  errormessage: string;
  errMsg: string;
  uploadDoc: any;
  uploadDoc2: any;
  fileUploads: any;
  TclcData: any;
  TclcId: any;
  TclcDocData: any;
  VodData: any;
  AdminUpload: any = [];
  FeeStatus: any;
  Status: string;
  dialogRef: MatDialogRef<any>;

  // Default VOD documents including Cover Letter
  defaultVodDocs = [
    { SrNo: 1, DocName: 'Original marksheet scan copies from First year to Final year with fail (if any)' },
    { SrNo: 2, DocName: 'Original scan copy of Passing Certificate/Degree Certificate/Internship Completion Certificate' },
    { SrNo: 3, DocName: 'Original scan copy of Registration Certificate and Identity Certificate issued by Govt. authority having photo (eg. Aadhar Card / Passport etc.)' },
    { SrNo: 5, DocName: 'Photo of student' },
    { SrNo: 6, DocName: 'Covering/Application Letter' }
  ];
 
  deliveryList = [
    { value: 'Soft', dropdownValue: 'Soft', Value: 'Soft Copy' },
    { value: 'Hard', dropdownValue: 'Hard', Value: 'Hard Copy' },
    { value: 'Both', dropdownValue: 'Both', Value: 'Both' }
  ];

  deliveryOptionList = [
    { value: 'IN', deliveryOptionValue: 'IN', Value: 'Within India Delivery' },
    { value: 'OFI', deliveryOptionValue: 'OFI', Value: 'Out Of India Delivery' },
  ];

  minDate = new Date(2000, 0, 1);
  private isLoadingDocs = false;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    private location: Location,
    private cdr: ChangeDetectorRef,
    public umsService: UmsService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.UpdateBtn = false;
    this.isdisabled = false;
    this.DocTable = false;
    this.DocView = false;
    this.SaveBtn = false;
    this.PayFee = false;
    this.Table = false;
    this.UpdateDisabled = false;
    this.PayDisabled = false;

    this.RegnNo = sessionStorage.getItem('StudentRGID');
    this.formattedPrn = this.RegnNo?.toString().padStart(8, '0');

    this.VodForm = this.fb.group({
      StuCourse: new FormControl('', Validators.required),
      StuClg: new FormControl('', Validators.required),
      StuName: new FormControl({ value: '', disabled: true }),
      StuRgNo: new FormControl({ value: '', disabled: true }),
      // Internship/Study Period
      StuFromDate: new FormControl('', [ this.validYearValidator]),
      StuToDate: new FormControl('', [ this.validYearValidator]),
      // Contact Details
      StuAdd: new FormControl(''),
      StuPin: new FormControl(''),
      StuPhone: new FormControl(''),
      StuEmail: new FormControl('', Validators.required),
      // Delivery Details
      DeliveryOpt: new FormControl('', Validators.required),
      EmailId: new FormControl(''),
      PostalAdd: new FormControl(''),
      DeliverAt: new FormControl(''),
      isSameAddr: new FormControl(false),
    
      arrData: this.fb.array([]),
      VodId: new FormControl('')
    });

    this.getStuId();
    this.getSecretData();

 
    this.VodForm.get('StuFromDate')?.valueChanges.subscribe(() => {
      this.checkDatePair('StuFromDate', 'StuToDate');
    });
    this.VodForm.get('StuToDate')?.valueChanges.subscribe(() => {
      this.checkDatePair('StuFromDate', 'StuToDate');
    });
  }


  validYearValidator = (control: AbstractControl) => {
    const inputDate = control.value;
    if (inputDate && !isNaN(Date.parse(inputDate))) {
      const year = new Date(inputDate).getFullYear();
      if (year < 1000 || year > 9999) return { invalidYear: true };
    }
    return null;
  };

  checkDatePair(fromKey: string, toKey: string) {
    const from = this.VodForm.get(fromKey)?.value;
    const to = this.VodForm.get(toKey)?.value;
    if (from && to && new Date(from) > new Date(to)) {
      this.VodForm.get(toKey)?.setErrors({ dateMismatch: true });
    } else {
      const toControl = this.VodForm.get(toKey);
      if (toControl?.hasError('dateMismatch')) toControl.setErrors(null);
    }
  }

  // ---------- Copy Address ----------
  copyAddress(event: any) {
    if (event.checked) {
      this.isreadonly = true;
      this.VodForm.controls['PostalAdd'].setValue(this.VodForm.controls['StuAdd'].value);
    } else {
      this.isreadonly = false;
      this.VodForm.controls['PostalAdd'].setValue('');
    }
  }

  // ---------- Document Row Management ----------
  get documentRows(): FormArray {
    return this.VodForm.get('arrData') as FormArray;
  }

  addDocumentRow(): void {
    const row = this.fb.group({
      DocumentName: new FormControl('', Validators.required),
      docFile: new FormControl(''),
      DocumentFile: new FormControl(''),
      TclcDocId: new FormControl('')
    });
    this.documentRows.push(row);
  }

  removeDocumentRow(index: number): void {
    if (this.documentRows.length > 1) {
      this.documentRows.removeAt(index);
      if (this.fileUploads && this.fileUploads[index]) {
        this.fileUploads.splice(index, 1);
      }
    } else {
      this.showError('At least one document is required');
    }
  }

  // ---------- API Calls ----------
  getSecretData() {
    this.spinner.show();
    this.umsService.getSecretData().subscribe({
      next: (res) => { 
        if (res.status) this.InstId = res.projectPharam['ClubPartTrans']; 
        this.spinner.hide(); 
      },
      error: () => this.spinner.hide()
    });
  }

  getStuId() {
    this.spinner.show();
    const payload = { StuRgNo: sessionStorage.getItem('StudentRGID') };
    this.umsService.fetchPersonalDetails(payload).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          const data = res.data[0];
          this.StuFullName = data.StuFullNameEng;
          this.RegnNo = data.StuRgNo;
          this.VodForm.controls['StuRgNo'].setValue(this.RegnNo);
          this.VodForm.controls['StuName'].setValue(this.StuFullName);
          this.VodForm.controls['StuEmail'].setValue(data.EmailID);
          this.VodForm.controls['StuPhone'].setValue(data.StuNumber);
          this.StuId = data.StuId;

          this.getCourseDataByStudent(this.StuId);
          this.getCollegeByStudent(this.StuId);
          this.ContactDetails(this.StuId);
          this.GetVodData(this.StuId);
        } else {
          this.SaveDisabled = true;
        }
        this.spinner.hide();
      },
      error: () => { 
        this.spinner.hide(); 
        this.SaveDisabled = true; 
      }
    });
  }

  getCourseDataByStudent(StuId: number) {
    const payload = { StuId };
    this.umsService.StudentSubjectSelectionById(payload).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          const latest = res.data[res.data.length - 1];
          this.getCourseData(latest['SubCoId']);
        }
      },
      error: () => this.spinner.hide()
    });
  }

  getCourseData(CoCode: string) {
    this.spinner.show();
    this.umsService.fetchCourseType({ CoCode }).subscribe({
      next: (res) => {
        if (res.status) {
          this.courseList = res.data;
          this.filteredCourseList = [...this.courseList];
          this.PreFix = res.data[0]?.CoRgPrfx;
          this.VodForm.controls['StuCourse'].setValue(res.data[0]?.CoCode);
        }
        this.spinner.hide();
      },
      error: () => this.spinner.hide()
    });
  }

  getCollegeByStudent(StuId: number) {
    const payload = { StuId };
    this.umsService.StudentSubjectSelectionById(payload).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          const latest = res.data[res.data.length - 1];
          this.getCollege(latest['SubCgId']);
        }
      }
    });
  }

  getCollege(CgCode: string) {
    this.spinner.show();
    this.umsService.getCollege({}).subscribe({
      next: (res) => {
        if (res.status) {
          this.CollegeList = res.data.filter(record => record.CgCode === CgCode);
          this.filteredCollegeList = [...this.CollegeList];
          this.VodForm.controls['StuClg'].setValue(this.CollegeList[0]?.CgCode);
        }
        this.spinner.hide();
      },
      error: () => this.spinner.hide()
    });
  }

  ContactDetails(StuId: number) {
    this.umsService.GetStuAddress({ StuId }).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          this.VodForm.controls['StuPin'].setValue(res.data[0].StuPinC);
          this.VodForm.controls['StuAdd'].setValue(res.data[0].FullAddress);
        }
      }
    });
  }

  GetVodData(StuId: number) {
    this.spinner.show();
    this.umsService.SearchTranscript({ StuId }).subscribe({
      next: (res) => {
        console.log('VOD Documents from API:', res);
        if (res.status && res.data.length) {
          const vodData = res.data.filter(d => d.CertType === 'VOD');
          if (vodData.length > 0) {
            this.UpdateBtn = true;
            this.SaveBtn = false;
            this.isdisabled = true;
            const d = vodData[0];
            this.VodForm.patchValue({
              VodId: d.TranscriptId,
              StuFromDate: d.StuFromDate,
              StuToDate: d.StuToDate,
              StuPin: d.StuPin,
              StuAdd: d.StuAdd,
              StuPhone: d.StuPhone,
              StuEmail: d.StuEmail,
              DeliveryOpt: d.DeliveryOpt,
              EmailId: d.EmailId,
              PostalAdd: d.PostalAdd,
              DeliverAt: d.DeliverAt
            });
            this.getTclcData(StuId);
          } else {
            this.UpdateBtn = false;
            this.SaveBtn = true;
            this.isdisabled = false;
            // First get TclcData to get TclcId, then GetVodDocuments
            this.getTclcData(StuId);
          }
        } else {
          this.UpdateBtn = false;
          this.SaveBtn = true;
          this.isdisabled = false;
          // First get TclcData to get TclcId, then GetVodDocuments
          this.getTclcData(StuId);
        }
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        this.UpdateBtn = false;
        this.SaveBtn = true;
        // First get TclcData to get TclcId, then GetVodDocuments
        this.getTclcData(StuId);
      }
    });
  }

  getTclcData(StuId: number) {
    this.spinner.show();
    const payload = { SessionId: parseInt(sessionStorage.getItem('session')), CertType: 'VOD' };
    this.umsService.GetTclcData(payload).subscribe({
      next: (res) => {
        if (res.status) {
          const allEntries = res.data.filter(d => d.StuId == StuId);
          
          const studentEntries = allEntries.filter(d => d.StatusBy === 'Student');
          if (studentEntries.length) {
            studentEntries.sort((a, b) => b.TclcId - a.TclcId);
            this.TclcData = [studentEntries[0]]; 
          } else {
            const orgEntries = allEntries.filter(d => d.StatusBy === 'Organization');
            if (orgEntries.length) {
              orgEntries.sort((a, b) => b.TclcId - a.TclcId);
              this.TclcData = [orgEntries[0]]; // Take the latest organization entry as fallback
            } else {
              this.TclcData = [];
            }
          }
          
          if (this.TclcData.length) {
            const tc = this.TclcData[0];
            this.FeeStatus = tc.FeeStatus;
            this.TclcId = tc.TclcId;
            this.UploadedDocs();

            if (tc.FeeStatus == 'Y') {
              this.PayFee = false;
              this.PayDisabled = true;
              this.PayRecpt = true;
            } else {
              this.PayDisabled = false;
              this.PayRecpt = false;
              this.ValidateFee(tc.StuId, tc.CertType, tc);
            }
            if (tc.CertStatus == 'REJ') {
              this.SaveBtn = false;
              this.UpdateBtn = true;
              this.UpdateDisabled = false;
              this.isdisabled = false;
            }
            else if (tc.CertType == 'VOD') {
              this.SaveBtn = false;
              this.UpdateBtn = true;
              this.isdisabled = true;
            }
            else {
              this.SaveBtn = true;
              this.SaveDisabled = true;
              this.UpdateBtn = false;
            }

            switch (tc.CertStatus) {
              case 'APR': this.Status = 'Approved'; this.UpdateDisabled = true; break;
              case 'APPAP': this.Status = 'Application Approved'; this.UpdateDisabled = true; break;
              case 'REJ': this.Status = 'Rejected'; this.UpdateDisabled = false; break;
              case 'REC': this.Status = 'Rectify'; this.UpdateDisabled = false; break;
              case 'Fees Paid': this.Status = 'Fees Paid'; this.UpdateDisabled = true; break;
              case 'ReSubmitted': this.Status = 'Re-Submitted'; this.UpdateDisabled = false; break;
              case 'Submitted': this.Status = 'Submitted'; this.UpdateDisabled = true; this.PayFee = true; break;
              case 'UFD': this.Status = 'Certificate Generated'; this.UpdateDisabled = true; this.UploadedDocs(); break;
              default: this.Status = tc.CertStatus; this.UpdateDisabled = false;
            }
            this.Table = true;
            if (tc.CertStatus == 'APR') this.Approved = true;
          } else {
            this.Table = false;
            this.SaveBtn = true;
            this.SaveDisabled = false;
            this.UpdateBtn = false;
            this.isdisabled = false;
          }
        }
        this.GetVodDocuments(StuId);
        
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
        this.Table = false;
        this.SaveBtn = true;
        this.SaveDisabled = false;
        this.UpdateBtn = false;
        this.isdisabled = false;
        this.GetVodDocuments(StuId);
      }
    });
  }
  GetVodDocuments(StuId: number) {
    if (this.isLoadingDocs) return;
    this.isLoadingDocs = true;
    this.spinner.show();
    const creds = this.VodForm.controls.arrData as FormArray;
    creds.clear();
  
    const payload = { 
      SessionId: parseInt(sessionStorage.getItem('session')), 
      CertType: 'VOD', 
      StuId,
      TclcId: this.TclcId || 0  // Pass TclcId from getTclcData, default to 0 if not set
    };
    
    this.umsService.GetTcLcDocDetails(payload).subscribe({
      next: (res) => {
        if (res.status && res.data.length) {
          this.DocView = true;
          this.SaveBtn = false;
          this.UpdateBtn = true;
          this.isdisabled = true;
          res.data.forEach((obj, i) => {
            creds.push(new FormGroup({
              DocumentName: new FormControl(obj.DocName),
              docFile: new FormControl(''),
              DocumentFile: new FormControl(obj.FileUpload),
              TclcDocId: new FormControl(obj.TclcDocId)
            }));
            if (!this.fileUploads) this.fileUploads = [];
            this.fileUploads[i] = obj.FileUpload;
          });
          this.DocTable = true;
        } else {
          this.CommonDocument(StuId);
        }
        this.spinner.hide();
        this.isLoadingDocs = false;
      },
      error: () => {
        this.spinner.hide();
        this.CommonDocument(StuId);
        this.isLoadingDocs = false;
      }
    });
  }

  CommonDocument(StuId: number) {
    this.DocTable = false;
    this.DocView = false;
    const payload = { ModuleType: 'VOD' };
    this.umsService.CommonDocument(payload).subscribe({
      next: (res) => {
        const creds = this.VodForm.controls.arrData as FormArray;
        creds.clear();
        if (res.status && res.data && res.data.length) {
          res.data.forEach(obj => {
            creds.push(new FormGroup({
              DocumentName: new FormControl(obj.DocName),
              docFile: new FormControl(''),
              DocumentFile: new FormControl(''),
              TclcDocId: new FormControl('')
            }));
          });
        } else {
          this.defaultVodDocs.forEach(doc => {
            creds.push(new FormGroup({
              DocumentName: new FormControl(doc.DocName),
              docFile: new FormControl(''),
              DocumentFile: new FormControl(''),
              TclcDocId: new FormControl('')
            }));
          });
        }
        this.DocTable = true;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.isdisabled = false;
        this.SaveDisabled = false;
        this.spinner.hide();
      },
      error: () => {
        const creds = this.VodForm.controls.arrData as FormArray;
        creds.clear();
        this.defaultVodDocs.forEach(doc => {
          creds.push(new FormGroup({
            DocumentName: new FormControl(doc.DocName),
            docFile: new FormControl(''),
            DocumentFile: new FormControl(''),
            TclcDocId: new FormControl('')
          }));
        });
        this.DocTable = true;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.isdisabled = false;
        this.spinner.hide();
      }
    });
  }

  // ---------- Form Validation ----------
  markFormTouched() {
    ['StuCourse', 'StuClg', 'StuEmail', 'DeliveryOpt'].forEach(field => {
      this.VodForm.get(field)?.markAsTouched();
    });
    if (this.VodForm.value.DeliveryOpt === 'Soft' || this.VodForm.value.DeliveryOpt === 'Both') {
      this.VodForm.get('EmailId')?.markAsTouched();
    }
    if (this.VodForm.value.DeliveryOpt === 'Hard' || this.VodForm.value.DeliveryOpt === 'Both') {
      this.VodForm.get('PostalAdd')?.markAsTouched();
      this.VodForm.get('DeliverAt')?.markAsTouched();
    }
  }

  // ---------- Save/Submit ----------
  Save() {
    this.markFormTouched();
    
    if (this.VodForm.invalid) {
      let errorMsg = 'Please fill all required fields:\n';
      const controls = this.VodForm.controls;
      if (controls['StuCourse'].invalid) errorMsg += '- Course is required\n';
      if (controls['StuClg'].invalid) errorMsg += '- College is required\n';
      if (controls['StuEmail'].invalid) errorMsg += '- Email is required\n';
      if (controls['DeliveryOpt'].invalid) errorMsg += '- Delivery Option is required\n';
      if ((this.VodForm.value.DeliveryOpt === 'Soft' || this.VodForm.value.DeliveryOpt === 'Both') && !this.VodForm.value.EmailId) {
        errorMsg += '- Email Id is required for Soft Copy delivery\n';
      }
      if ((this.VodForm.value.DeliveryOpt === 'Hard' || this.VodForm.value.DeliveryOpt === 'Both') && !this.VodForm.value.PostalAdd) {
        errorMsg += '- Postal Address is required for Hard Copy delivery\n';
      }
      if ((this.VodForm.value.DeliveryOpt === 'Hard' || this.VodForm.value.DeliveryOpt === 'Both') && !this.VodForm.value.DeliverAt) {
        errorMsg += '- Delivery Location is required for Hard Copy delivery\n';
      }
      this.showError(errorMsg);
      return;
    }

    const creds = this.VodForm.get('arrData') as FormArray;
    let missingDocs = [];
    
    creds.controls.forEach((ctrl, idx) => {
      const docName = ctrl.get('DocumentName')?.value;
      const docFile = ctrl.get('DocumentFile')?.value;
      
      if (!docName || docName.trim() === '') {
        ctrl.get('DocumentName')?.setErrors({ required: true });
        ctrl.get('DocumentName')?.markAsTouched();
      }
      
      if (!docFile) {
        missingDocs.push(docName || `Document ${idx+1}`);
        ctrl.get('DocumentFile')?.setErrors({ required: true });
        ctrl.get('DocumentFile')?.markAsTouched();
      }
    });

    if (missingDocs.length > 0) {
      this.showError(`Please upload files for:\n${missingDocs.join('\n')}`);
      return;
    }
    this.Submit();
  }

  Submit() {
    this.spinner.show();
    this.SubmitTclc();
  }

  SubmitTclc() {
    const payload = {
      StuFaculty: '', 
      StuCourse: this.VodForm.value.StuCourse,
      StuCollege: this.VodForm.value.StuClg, 
      StuExam: '', 
      StuBranch: '',
      SnNo: parseInt(sessionStorage.getItem('session')), 
      CertType: 'VOD',
      DestClg: '', 
      Reason: '', 
      Other: '', 
      FeeStatus: '', 
      CertStatus: 'Submitted',
      StuId: this.StuId, 
      StuName: this.VodForm.value.StuName,
      Comment: '', 
      CertScr: '', 
      StatusBy: sessionStorage.getItem('loginId'),
      DocStatus: 'Y'
    };
    
    this.umsService.AddTclc(payload).subscribe({
      next: (res) => { 
        if (res.status) {
          if (res.data && res.data.TclcId) {
            this.TclcId = res.data.TclcId;
          }
          this.AddTranscript();
        } else {
          this.showError(res.message);
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.showError(err.error?.message || 'Failed to submit TCLC');
      }
    });
  }

  AddTranscript() {
    const form = this.VodForm.value;
    const payload: any = {
      StuId: this.StuId,
      StuFromDate: this.datePipe.transform(form.StuFromDate, 'yyyy-MM-dd'),
      StuToDate: this.datePipe.transform(form.StuToDate, 'yyyy-MM-dd'),
      CouncilRegNo: 'NA',
      StuCertCopies: '0',
      FeeStatus: '',
      CertType: 'VOD',
      CertStatus: 'Submitted',
      StatusBy: sessionStorage.getItem('loginId'),
      DocStatus: 'Y',
      Comment: '',
      SnNo: parseInt(sessionStorage.getItem('session')),
      StuName: form.StuName,
      PostalAdd: form.PostalAdd,
      DeliverAt: form.DeliverAt,
      EmailId: form.EmailId,
      DeliveryOpt: form.DeliveryOpt,
      StuCourse: form.StuCourse,
      StuCollege: form.StuClg,
      StuAdd: form.StuAdd,
      StuEmail: form.StuEmail,
      StuPin: form.StuPin,
      StuPhone: form.StuPhone,
      StuPRN: this.RegnNo
    };
    this.umsService.AddTranscript(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.AddTclcDoc();
        } else {
          this.showError(res.message);
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.showError(err.error?.message || 'Failed to submit transcript');
      }
    });
  }

  AddTclcDoc() {
    let isError = false;
    const creds = this.VodForm.get('arrData') as FormArray;
    const promises = creds.value.map((element, idx) => {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          const payload = {
            StuId: this.StuId, 
            CertType: 'VOD', 
            DocName: element.DocumentName,
            FileUpload: this.fileUploads[idx], 
            SrNo: idx + 1,
            TclcId: this.TclcId || 0  // Pass TclcId
          };
          this.umsService.AddTclcDoc(payload).subscribe({
            next: (res) => { 
              if (!res.status) isError = true; 
              resolve(); 
            },
            error: () => { 
              isError = true; 
              resolve(); 
            }
          });
        }, idx * 2000);
      });
    });
    Promise.all(promises).then(() => {
      this.spinner.hide();
      if (!isError) {
        this.showSuccess('Submitted Successfully');
        this.GetVodData(this.StuId);
        this.saveApplicationDetails();
      } else {
        this.showError(this.errMsg || 'Upload failed');
      }
    });
  }

  // ---------- Update ----------
  Update() {
    if (this.VodForm.invalid) {
      this.markFormTouched();
      return;
    }
    this.spinner.show();
    const form = this.VodForm.value;
    const payload: any = {
      StuId: this.StuId,
      StuFromDate: this.datePipe.transform(form.StuFromDate, 'yyyy-MM-dd'),
      StuToDate: this.datePipe.transform(form.StuToDate, 'yyyy-MM-dd'),
      CouncilRegNo: 'NA',
      StuCertCopies: '0',
      FeeStatus: this.FeeStatus || 'Y',
      CertType: 'VOD',
      CertStatus: 'ReSubmitted',
      StatusBy: sessionStorage.getItem('loginId'),
      DocStatus: 'Y',
      Comment: '',
      SnNo: parseInt(sessionStorage.getItem('session')),
      StuName: form.StuName,
      TranscriptId: form.VodId,
      PostalAdd: form.PostalAdd,
      EmailId: form.EmailId,
      DeliveryOpt: form.DeliveryOpt,
      StuCourse: form.StuCourse,
      StuCollege: form.StuClg,
      StuAdd: form.StuAdd,
      StuEmail: form.StuEmail,
      StuPin: form.StuPin,
      StuPhone: form.StuPhone,
      StuPRN: this.RegnNo,
      DeliverAt: form.DeliverAt
    };
    this.umsService.UpdateTranscript(payload).subscribe({
      next: (res) => { 
        if (res.status) {
          this.UpdateTclc();
        } else {
          this.showError(res.message);
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.showError(err.error?.message);
      }
    });
  }

  UpdateTclc() {
    const payload = {
      StuFaculty: '', StuCourse: this.VodForm.value.StuCourse,
      StuCollege: this.VodForm.value.StuClg, StuExam: '', StuBranch: '',
      SnNo: parseInt(sessionStorage.getItem('session')), CertType: 'VOD',
      DestClg: '', Reason: '', Other: '', FeeStatus: this.FeeStatus || 'Y',
      CertStatus: 'ReSubmitted', StuId: this.StuId, Comment: '', CertScr: '',
      StatusBy: sessionStorage.getItem('loginId'), DocStatus: 'Y', TclcId: this.TclcId
    };
    this.umsService.UpdateTclc(payload).subscribe({
      next: (res) => { 
        if (res.status) {
          this.UpdateTclcDoc();
        } else {
          this.showError(res.message);
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.showError(err.error?.message);
      }
    });
  }

  UpdateTclcDoc() {
    let isError = false;
    const creds = this.VodForm.get('arrData') as FormArray;
    const promises = creds.value.map((element, idx) => {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          const payload = {
            StuId: this.StuId, 
            CertType: 'VOD', 
            DocName: element.DocumentName,
            FileUpload: this.fileUploads[idx] || element.DocumentFile,
            TclcDocId: element.TclcDocId, 
            SrNo: idx + 1,
            TclcId: this.TclcId || 0  // Pass TclcId
          };
          this.umsService.UpdateTclcDoc(payload).subscribe({
            next: (res) => { 
              if (!res.status) isError = true; 
              resolve(); 
            },
            error: () => { 
              isError = true; 
              resolve(); 
            }
          });
        }, idx * 2000);
      });
    });
    Promise.all(promises).then(() => {
      this.spinner.hide();
      if (!isError) {
        this.showSuccess('Updated Successfully');
        this.GetVodData(this.StuId);
      } else {
        this.showError(this.errMsg || 'Update failed');
      }
    });
  }

  // ---------- Payment ----------
  PayFees() {
    const data = this.VodForm.value;
    this.umsService.setTclcData([{
      StuCourse: data.StuCourse, StuClg: data.StuClg,
      SnNo: parseInt(sessionStorage.getItem('session')), CertType: 'VOD',
      StudentName: data.StuName
    }]);
    this.router.navigate(['TCLCFees']);
  }

  getFeeTempData() {
    this.spinner.show();
    this.umsService.fetchFeeTempTclc({ FeeType: 'VOD' }).subscribe({
      next: (res) => {
        if (res.status) {
          this.openPaymentReceipt(res.data[0]['TemplateCode']);
        } else {
          this.spinner.hide();
        }
      },
      error: () => this.spinner.hide()
    });
  }

  openPaymentReceipt(tempCode: string) {
    this.dialog.open(PaymentReceiptComponent, {
      width: '90vh', height: '80vh',
      data: {
        SnNo: parseInt(sessionStorage.getItem('session')),
        TemplateCode: tempCode, FeeType: 'VOD',
        studentname: this.StuFullName,
        college: this.VodForm.value.StuClg,
        course: this.VodForm.value.StuCourse
      },
      disableClose: true
    });
  }

  ValidateFee(StuId: number, FeeType: string, data: any) {
    this.umsService.ValidateFees({ StuId, FeeType, SnNo: sessionStorage.getItem('session') }).subscribe({
      next: () => this.getFeeTempData2(StuId, FeeType, data)
    });
  }

  getFeeTempData2(StuId: number, FeeType: string, data: any) {
    this.umsService.fetchFeeTempTclc({ FeeType }).subscribe({
      next: (res) => {
        if (res.status) {
          this.SearchFeeDetails(res.data[0]['TemplateCode'], StuId, data);
        } else {
          this.spinner.hide();
        }
      }
    });
  }

  SearchFeeDetails(tempCode: string, StuId: number, data: any) {
    this.umsService.getSearchTranscriptFeeDetails({
      FeeTemplateCode: tempCode, StuId, FeeHistory: 0, SnNo: sessionStorage.getItem('session')
    }).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.updateTC(StuId, data);
        } else {
          this.PayDisabled = false;
          this.PayRecpt = false;
          this.PayFee = true;
        }
      }
    });
  }

  updateTC(StuId: number, data: any) {
    const payload = {
      StuFaculty: data.StuFaculty, StuCourse: data.StuCourse, StuCollege: data.StuCollege,
      StuExam: data.StuExam, StuBranch: data.StuBranch, SnNo: parseInt(sessionStorage.getItem('session')),
      CertType: data.CertType, DestClg: data.DestClg, Reason: data.Reason, FeeStatus: 'Y',
      CertStatus: 'Fees Paid', StuId: data.StuId, TclcId: data.TclcId, Comment: '', CertScr: '',
      StatusBy: sessionStorage.getItem('loginId')
    };
    this.umsService.UpdateTclc(payload).subscribe(() => this.getTclcData(StuId));
  }

  // ---------- Document Upload ----------
  UploadedDocs() {
    this.spinner.show();
    const payload = {
      SessionId: parseInt(sessionStorage.getItem('session')),
      StuId: this.StuId,
      CertType: 'VOD',
      TclcId: this.TclcId || 0  // Added TclcId to payload
    };
    this.umsService.GetTcLcDocUploadDetails(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.spinner.hide();
          this.AdminUpload = res.data;
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
      }
    });
  }

  onFileSelected(event: Event, rowIndex: number) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;
    
    if (file.size > 3000000) {
      this.showError('File size must be less than 3 MB');
      input.value = '';
      return;
    }
    
    const ext = file.name.split('.').pop()?.toLowerCase();
    if (ext !== 'pdf') {
      this.showError('Only PDF files are allowed');
      input.value = '';
      return;
    }
    
    this.convertToBase64(file, rowIndex);
    const formArray = this.VodForm.get('arrData') as FormArray;
    formArray.at(rowIndex).get('DocumentFile')?.setValue(file.name);
  }

  convertToBase64(file: File, rowIndex: number) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (!this.fileUploads) this.fileUploads = [];
      this.fileUploads[rowIndex] = reader.result;
      const fa = (this.VodForm.get('arrData') as FormArray).at(rowIndex);
      fa.get('docFile')?.setValue(reader.result?.toString().split(',')[1]);
    };
  }

  showbase64(fileBase64: string) {
    if (fileBase64) {
      this.dialog.open(PdfviewerComponent, { 
        width: '400px', 
        height: '500px', 
        data: fileBase64 
      });
    }
  }

  downloadCertificate() {
    if (this.AdminUpload.length) {
      this.dialog.open(PdfviewerComponent, { 
        width: '400px', 
        height: '500px', 
        data: this.AdminUpload[0].FileUpload 
      });
    }
  }

  saveApplicationDetails() {
    this.umsService.saveApplicationDetails({
      StuId: this.StuId, 
      SessionId: parseInt(sessionStorage.getItem('session')),
      CgCode: this.VodForm.value.StuClg, 
      CoCode: this.VodForm.value.StuCourse,
      ApplicationName: 'VOD', 
      ApplicationSubDate: new Date().toISOString().slice(0, 10)
    }).subscribe();
  }

  // ---------- Navigation ----------
  Back() { 
    this.location.back(); 
  }

  // ---------- Popup Methods ----------
  showSuccess(msg: string) {
    this.dialogRef = this.modalPopupService.openPopup(AlertboxComponent, {
      message: msg, title: 'Information', icon: 'fas fa-check'
    });
  }

  showError(msg: string) {
    this.dialogRef = this.modalPopupService.openPopup(AlertboxComponent, {
      message: msg, title: 'Alert', icon: 'fas fa-close'
    });
  }
}